"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const ExtendableProvider_1 = require("./ExtendableProvider");
/**
 * Compiler pass that adds extendables to the manager.
 */
class ExtendableCompilerPass {
    /**
     * Constructs the compiler pass.
     *
     * @param bases
     * @param extensions
     */
    constructor(bases, extensions) {
        this.bases = bases;
        this.extensions = extensions;
    }
    /**
     * @inheritDoc
     */
    process(container) {
        let extendables = [];
        Object.entries(this.bases).forEach(([key, classReference]) => {
            extendables.push([classReference, this.extensions[key] || classReference]);
        });
        container.addDefinition("extendable.provider", {
            class: ExtendableProvider_1.default,
            argumentList: [
                extendables
            ],
        });
    }
}
exports.default = ExtendableCompilerPass;
